import React from "react";
import NoOpening from "../../components/sections/careers/NoOpening";
import OpenVacancy from "../../components/sections/careers/OpenVacancy";
import Breadcrumbs from "../../components/common/Breadcrumbs";


const Careers = () => {
  const opening = false;
  return (
    <div className="w-full max-w-full mx-auto pt-4">
      <Breadcrumbs />
      {!opening ? <NoOpening /> : <OpenVacancy />}
    </div>
  );
};

export default Careers;
